import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import UpdateAccountForm from 'Forms/UpdateAccountForm';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import { updateUserProfile } from 'State/User/UserActions';
import { updateName } from 'Utils/UserCookie';
import { tealiumTrackEvent, trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { updateConfirmation } from 'State/Layouts/LayoutActions';
import { useNavigate } from 'react-router-dom';
import { updatePaymentAccount } from 'Api/ProfileApi';

export const EditProfileContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routes = useSelector((s) => s.appConfig.routes);
  const user = useSelector((s) => s.user);

  const goToMyaccount = () => navigate(routes.myAccount);
  const handleCancelClick = () => goToMyaccount();
  const handleUpdateSubmit = async (values) => {
    try {
      const payload = { ...user, ...values };
      const res = await updatePaymentAccount(payload);
      if (res) {
        // todo: check res here
        dispatch(updateUserProfile(payload));
        updateName(payload);
        dispatch(updateConfirmation('You have successfully updated your Profile'));
        tealiumTrackEvent(TRACKING_ENUMS.EVENT_EDIT_PROFILE_COMPLETED, {
          button_location: 'my account',
          button_text: 'Save Changes',
        });
        trackEvent(TRACKING_ENUMS.EVENT_UPDATE_ACCOUNT_COMPLETED);
        trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_PROFILE_EDIT, {
          page_item_title: 'Save Changes',
        });
        goToMyaccount();
      } else {
        throw new Error(res);
      }
    } catch (e) {
      return onSubmitReactFormError('There was an issue with your account information.');
    }
  };

  return (
    <CenterFrameLayout title="Edit Account" showLoader={false}>
      <div className="centerForm">
        <UpdateAccountForm
          initialValues={{ firstName: user.firstName || '', lastName: user.lastName || '' }}
          handleCancelClick={handleCancelClick}
          onFormSubmit={handleUpdateSubmit}
          submitButtonText="Save Changes"
        />
      </div>
    </CenterFrameLayout>
  );
};
